import React, { useState } from 'react';
import SymbolCell from './SymbolCell.js';
// S-DM-012: generated from RepoLens.Shared.Models.SearchSymbolResult — do
// not hand-edit the SyntaxNode shape here. Run
// `dotnet run --project tools/RepoLens.CodeGen.TypeScriptContracts` after
// changing the C# DTO, and commit the regenerated file.
import type { SyntaxNode } from './generated/searchContracts.js';
export type { SyntaxNode };

const GHE_HOST =
  (import.meta.env.VITE_GHE_HOST as string | undefined) ??
  'https://ghe.coxautoinc.com';

function buildNavigateUrl(result: SyntaxNode): string {
  const { repositoryId, branch, filePath, span } = result;
  if (/^[^/]+\/[^/]+$/.test(repositoryId)) {
    return `${GHE_HOST}/${repositoryId}/blob/${branch}/${filePath}#L${span.startLine}`;
  }
  return `/search?q=${encodeURIComponent(result.symbol)}&repo=${encodeURIComponent(repositoryId)}`;
}

interface ResultRowProps {
  result: SyntaxNode;
  query: string;
}

export default function ResultRow({ result, query }: ResultRowProps): React.ReactElement {
  const [pathCopied, setPathCopied] = useState(false);

  function handleRowClick(): void {
    window.location.href = buildNavigateUrl(result);
  }

  function handleRowKeyDown(e: React.KeyboardEvent<HTMLTableRowElement>): void {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      window.location.href = buildNavigateUrl(result);
    }
  }

  function handleCopyPath(e: React.MouseEvent): void {
    e.stopPropagation();
    navigator.clipboard.writeText(result.filePath).catch(() => {});
    setPathCopied(true);
    setTimeout(() => setPathCopied(false), 1500);
  }

  function handleNavigate(e: React.MouseEvent): void {
    e.stopPropagation();
    window.location.href = buildNavigateUrl(result);
  }

  return (
    <tr
      tabIndex={0}
      data-testid="result-row"
      className="result-row"
      onClick={handleRowClick}
      onKeyDown={handleRowKeyDown}
    >
      <SymbolCell symbol={result.symbol} query={query} />
      <td>
        <span className="type-badge">{result.nodeType}</span>
      </td>
      <td className="file-path-cell" title={result.filePath || undefined}>
        {result.filePath || <span className="file-path-empty" aria-label="file path unknown">—</span>}
      </td>
      <td>
        {result.repositoryId}
        <span className="row-actions">
          <button
            type="button"
            className="row-action-btn"
            aria-label="Navigate to file"
            onClick={handleNavigate}
          >
            ↗
          </button>
          <button
            type="button"
            data-testid="copy-path-btn"
            className="row-action-btn"
            aria-label="Copy file path"
            onClick={handleCopyPath}
          >
            {pathCopied ? 'Copied!' : '⎘'}
          </button>
        </span>
      </td>
    </tr>
  );
}
